<!--
 * @Author: YuanYuan
 * @Date: 2024-02-28 09:52:39
 * @LastEditTime: 2025-09-11 15:07:25
 * @description: 查询条件中el-select控件
-->
<template>
  <el-select v-bind="$attrs" v-on="$listeners" class="w-full">
    <span slot="prefix">{{label}}{{$t('common.colon')}}</span>
    <el-option v-if="showAll" :label="allLabel" :value="allValue"></el-option>
    <el-option
      v-for="item in data"
      :key="item[valueKey]"
      :label="item[labelKey]"
      :value="item[valueKey]">
    </el-option>
  </el-select>
</template>

<script setup>
import { toRefs } from 'vue'
import i18n from '@/i18n'

const props = defineProps({
  label: {
    type: String,
    default: '-'
  },
  data: {
    type: Array,
    default: () => ([])
  },
  showAll: {
    type: Boolean,
    default: true
  },
  // 全部项显示名
  allLabel: {
    type: String,
    default: i18n.t('common.all')
  },
  // “全部”项的值默认为空
  allValue: {
    type: String,
    default: ''
  },
  labelKey: {
    type: String,
    default: 'label'
  },
  valueKey: {
    type: String,
    default: 'value'
  }
})

const { label, allLabel, showAll, allValue, data, labelKey, valueKey } = toRefs(props)

</script>
